export default __webpack_public_path__ + "static/media/tech_karier.e9ada46a.png";